export class ApiError extends Error {
  constructor(public status: number, message: string, public details?: unknown) {
    super(message);
  }
}

async function handle(res: Response) {
  if (res.ok) {
    if (res.status === 204) return null;
    return res.json();
  }
  let body: unknown = null;
  try {
    body = await res.json();
  } catch {
    // ignore
  }
  let message = `http_${res.status}`;
  if (body && typeof body === 'object') {
    // Prefer a human-readable `message` (e.g. friendly validation copy) over
    // the machine `error` code so business users see plain English.
    const msg = (body as { message?: unknown }).message;
    const err = (body as { error?: unknown }).error;
    if (typeof msg === 'string' && msg.length > 0) message = msg;
    else if (typeof err === 'string' && err.length > 0) message = err;
  }
  throw new ApiError(res.status, message, body);
}

export function apiFetch<T = unknown>(path: string, opts?: { signal?: AbortSignal }): Promise<T> {
  return fetch(path, { credentials: 'include', signal: opts?.signal }).then(handle) as Promise<T>;
}

export function apiAction<T = unknown>(
  path: string,
  body: unknown,
  method: 'POST' | 'PUT' | 'PATCH' | 'DELETE' = 'POST',
  opts?: { signal?: AbortSignal },
): Promise<T> {
  return fetch(path, {
    method,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
    signal: opts?.signal,
  }).then(handle) as Promise<T>;
}
